module.exports = __webpack_public_path__ + "static/media/up.836a1286.png";